export default __webpack_public_path__ + "static/media/pdf.e9dfa5c2.svg";